import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { registerSW } from "virtual:pwa-register";
import { configureApi } from "@safers/api";

import "pretendard/dist/web/variable/pretendardvariable.css";
import { App } from "./App";
import "./styles/globals.css";

const trimmedContextPath = (import.meta.env.VITE_CONTEXT_PATH || "").replace(/^\/+|\/+$/g, "");
const contextPath = trimmedContextPath ? `/${trimmedContextPath}` : "";

configureApi({ baseURL: `${import.meta.env.VITE_API_BASE_PATH ?? contextPath}/api` });

registerSW({ immediate: true });

const queryClient = new QueryClient({ defaultOptions: { queries: { retry: 1 } } });

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter basename={contextPath || "/"}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </BrowserRouter>
  </StrictMode>
);
